/** This includes all options of the Cookie Monster Framework and their relevant data */
const settings = {};
export default settings;
